import { List, Record, RecordOf } from 'immutable';
import { HierarchyEntity, HierarchyType } from 'services/resources';
import { SelectedEntityType } from './actions';

export const HierarchyEntityRecordFactory = Record<HierarchyEntity>({
  id: 0, // 0 does not exist
  parentId: null,
  name: '',
});

export const HierarchyEntitiesRecordFactory = (data: HierarchyEntity[]) => List(data.map(HierarchyEntityRecordFactory));

export interface HierarchyTreeState {
  loading: boolean;
  values: List<RecordOf<HierarchyEntity>>;
}

export const HierarchyTreeStateFactory = Record<HierarchyTreeState>({
  loading: false,
  values: List(),
});

export interface HierarchyState {
  hierarchy: HierarchyTreeState;
  selectedEntity: SelectedEntityType;
}

export const HierarchyStateFactory = Record<HierarchyState>({
  hierarchy: HierarchyTreeStateFactory(),
  selectedEntity: HierarchyType.SELF,
});
